<template>
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
        <div class="wrapper">
            <div class="product-detail devices-detail container">
                <!-- Breadcrumb -->
                <div class="row">
                    <div class="col">
                        <ol class="breadcrumb">
                            <li><a href="#">Cash Market</a></li>
                            <li><a href="#">Dispositivos Móviles</a></li>
                            <li class="active">Samsung Galaxy S9 Plus</li>
                        </ol>
                    </div>
                </div>

                <div class="row devices-detail__container">
                    <!-- Product Detail Image Gallery -->
                    <div class="col-lg-6 p-l-0 product__big-img-gallery">
                        <div class="featured-image">      
                            <div class="offer--cards__bg product-photo" id="ProductPhoto">
                                <img id="ProductPhotoImg" class="zoom_mouse product_variant_image" src="/images/offes-news-img/big-cell-samsung.png">
                            </div>
                        </div>
                        <div class="shop-product__small-image-gallery-wrapper">
                            <div class="shop-product__small-image-gallery-slider owl-carousel owl-loaded owl-drag" id="ProductThumbs">
                                <div class="owl-stage-outer">
                                    <div class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all 0s ease 0s; width: 575px;">
                                        <!-- Items 1 -->
                                        <div class="carousel-item active">
                                            <div class="single-image">
                                                <a class="product-single__thumbnail active" href="">
                                                    <img src="/images/offes-news-img/cell-samsung-1.png" alt="11. Side Ottoman">
                                                </a>
                                            </div>
                                        </div>
                                        <!-- Items 2 -->
                                        <div class="carousel-item active">
                                            <div class="single-image">
                                                <a class="product-single__thumbnail active" href="">
                                                    <img src="/images/offes-news-img/cell-samsung-2.png" alt="11. Side Ottoman">
                                                </a>
                                            </div>
                                        </div>
                                        <!-- Items 3 -->
                                        <div class="carousel-item active">
                                            <div class="single-image">
                                                <a class="product-single__thumbnail active" href="">
                                                    <img src="/images/offes-news-img/cell-samsung-1.png" alt="11. Side Ottoman">
                                                </a>
                                            </div>
                                        </div>
                                        <!-- Items 4 -->
                                        <div class="carousel-item active">
                                            <div class="single-image">
                                                <a class="product-single__thumbnail active" href="">
                                                    <img src="/images/offes-news-img/cell-samsung-2.png" alt="11. Side Ottoman">
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="owl-nav">
                                    <div class="owl-prev">
                                        <i class="ti-angle-left"></i>
                                    </div>
                                    <div class="owl-next">
                                        <i class="ti-angle-right"></i>
                                    </div>
                                </div>
                                <div class="owl-dots disabled"></div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Product Detail Content -->
                    <div class="col-lg-6 cash-product-detail__content">
                        <form method="" action="" id="AddToCartForm" class="product-content-inner"> 
                            <div class="cash-product__description">
                                <div class="cash-product__title">
                                    <h2 class="cash-cart_title">Samsung Galaxy S9 Plus</h2>
                                </div>
                                <div class="cash-product__rating mb-15 classification--stars">
                                    <img src="/images/offes-news-img/stars-orange.png" />
                                </div>
                                <div class="cash-product__price mb-30">
                                    <div class="devices--list__price product-price">
                                        <Label>Valor :</Label>
                                        <sub class="sign-price">RD$</sub> 
                                        <span class="currency-price">10,200</span> 
                                        <sub class="cent-price">.00</sub>
                                    </div>
                                </div>

                                <div class="cash-">
                                    <p>Tamano : <strong>64gb</strong></p>
                                </div>
                                <div class="cash-product__amounts">

                                </div>

                                <div class="cash-product__buttons mb-30">
                                    <button class="btn btn-success cart-disable" type="button" style="width:100%;">
                                        <span class="cart-text">Solicitar</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
                
                <div class="row devices-detail__info">
                    <div class="col offer--cards__bg">
                        <div class="devices-info">
                            <h3>Información de producto</h3>
                            <p>Aenean non accumsan ante. Duis et risus accumsan sem tempus porta nec sit amet est. Sed ut euismod quam. Suspendisse potenti. Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus. Vivamus luctus maximus vestibulum. Duis et risus accumsan sem tempus porta nec sit amet est. Sed ut euismod quam.  Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus. Vivamus luctus maximus vestibulum. Duis et risus accumsan sem tempus porta nec sit amet est. Sed ut euismod quam.</p>
                        </div>
                        <div class="devices-table">
                            <table class="product-detail__table" style="width:100%">
                                <tr>
                                    <th class="table-header__devices col-md-5">Color :</th>
                                    <td class="col-md-7">Negro</td>
                                </tr>
                                <tr>
                                    <th class="table-header__devices col-md-5">Tamaño :</th>
                                    <td class="col-md-7">32gb</td>
                                </tr>
                                <tr>
                                    <th class="table-header__devices col-md-5">Número de modelo del producto :</th>
                                    <td class="col-md-7"> - </td>
                                </tr>
                                <tr>
                                    <th class="table-header__devices col-md-5">Dimensiones del producto :</th>
                                    <td class="col-md-7">147.7 x 68.7 x 8.5</td>
                                </tr>
                                <tr>
                                    <th class="table-header__devices col-md-5">Peso :</th>
                                    <td class="col-md-7">163</td>
                                </tr>
                                <tr>
                                    <th class="table-header__devices col-md-5">Sistema operativo : </th>
                                    <td class="col-md-7">Android</td>
                                </tr>
                                <tr>
                                    <th class="table-header__devices col-md-5">Cámara Principal - Resolución : </th>
                                    <td class="col-md-7">12.0 MP</td>
                                </tr>
                                <tr>
                                    <th class="table-header__devices col-md-5">Procesador con velocidad CPU : </th>
                                    <td class="col-md-7">2.8GHz, 1.7GHz</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Reviews -->
                <div class="row review-clients">
                    <div class="col">
                        <h2>Opiniones de clientes</h2>
                        <!-- Opinion #1 -->
                        <div class="review-container offer--cards__bg">
                            <div class="row">
                                <div class="col-md-2 review-container__users">
                                    <img src="/images/offes-news-img/icon-person.png" />
                                    <span>Yazmin Torres</span>
                                    <div class="classification--stars">
                                        <img src="/images/offes-news-img/stars-orange.png" />
                                    </div>
                                </div>

                                <div class="col-md-8 review-container__text">
                                    <p>Aenean non accumsan ante. Duis et risus accumsan sem tempus porta nec sit amet est. Sed ut euismod quam. Suspendisse potenti. Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus  Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus </p>
                                </div>
                            </div>
                        </div>
                        <!-- Opinion #2 -->
                        <div class="review-container offer--cards__bg">
                            <div class="row">
                                <div class="col-md-2 review-container__users">
                                    <img src="/images/offes-news-img/icon-person.png" />
                                    <span>Juan Torres</span>
                                    <div class="classification--stars">
                                        <img src="/images/offes-news-img/stars-orange.png" />
                                    </div>
                                </div>

                                <div class="col-md-8 review-container__text">
                                    <p>Aenean non accumsan ante. Duis et risus accumsan sem tempus porta nec sit amet est. Sed ut euismod quam. Suspendisse potenti. Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus  Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus </p>
                                </div>
                            </div>
                        </div>
                        <!-- Opinion #3 -->
                        <div class="review-container offer--cards__bg">
                            <div class="row">
                                <div class="col-md-2 review-container__users">
                                    <img src="/images/offes-news-img/icon-person.png" />
                                    <span>Margaret Lopez</span>
                                    <div class="classification--stars">
                                        <img src="/images/offes-news-img/stars-orange.png" />
                                    </div>
                                </div>

                                <div class="col-md-8 review-container__text">
                                    <p>Aenean non accumsan ante. Duis et risus accumsan sem tempus porta nec sit amet est. Sed ut euismod quam. Suspendisse potenti. Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus  Aliquam fringilla orci tincidunt, ullamcorper erat in, malesuada metus </p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductDetailDevices'
}
</script>

<style lang="css" scoped>
img {
    max-width: 100%;
}
h1 {
    font-size: 26px;
}
a {
    color:#213F99;
}
a:hover {
    text-decoration: underline;
    color:#213F99;
}
/* Breadcrum */
.breadcrumb {
    margin-bottom: 0px;
    text-transform: capitalize;
}
.breadcrumb li.active {
    color: #000000;
}
.breadcrumb li a {
    color: #898989;
}
/* Classification Star */
.stars--item {
    text-align: left;
    max-width:150px;
    width: 100%;
    height: 38px;
}
.devices-table {
    margin: 30px 0 15px;
}
.devices-table tr {
    border-bottom: 1px solid #d4d9ddbd; 
}
.devices-table td {
    color: #213F99;
}
.devices-info p,
.devices-table tr,
.devices-table td {
    font-size: 16px; 
}
.table-header__devices {
    background: #F5F5F5;
    padding: 15px 30px;
}
.product-detail .offer--cards__bg {
    padding: 30px 40px;
}
.offer--cards__bg {
    background: #fff;
    border: 1px solid #ccc;
}
.sign-price,
.currency-price {
    vertical-align: middle;
}
.currency-price {
    font-size: 24px;
}
.cent-price {
    vertical-align: sub;
    margin-left: -5px;
}
.devices-detail__container {
    margin-bottom: 40px;
}
.product-photo {
    text-align: center;
    margin-bottom: 30px;
}
.carousel-item {
    width: 116.75px;
    margin-right: 5px;
    float: left;
}

/* Review Clients */
.review-container {
    max-height: 218px;
    height: 100%;
    padding: 0px 40px!important;
    margin: 15px 0 0px;
}
.review-container__users {
    text-align: center;
    padding: 20px;
}
.review-container__users span {
    display: block;
    margin: 15px 0 0px;
    font-size: 16px;
}
.review-container__text {
    padding: 50px 35px 20px;
    font-size: 16px;
    color: #707070;
}
</style>


// WEBPACK FOOTER //
// product-detail-devices.vue?0adf03c5